import { connect } from "react-redux";

import Kopfzeile from "./Kopfzeile";

import { switchLocale } from "../lng/Locales";
import { clearAuthToken, userLogoutAction } from "../model/Benutzer";

export default connect(state => ({
	locale_i18n_key: state.current_locale_i18n_key,
	authorized: state.user.isAuthorized,
	sd_status: state.ablauf.master.sd_status
}), dispatch => ({
	selectLocale: locale_name => {
		switchLocale(locale_name, dispatch);
	},
	logout: () => {
		clearAuthToken();
		dispatch(userLogoutAction());
	}
}))(Kopfzeile);
